<template>
  <div class="about">
    <b-container class="text-left">
      <h1 class="mt-2">Regisztráció</h1>
      <p>Regisztráljon meglévő fiókjával:</p>
      <div class="bordered-container mt-4">
        <b-row class="mt-2">
          <b-col cols="6">
            <b-button class="social rounded google" @click="authenticateGoogle" :disabled="!!relayState">
              <GooglePlusIcon :size="24" />Google</b-button
            >
          </b-col>
          <b-col cols="6">
            <b-button v-if="!relayState" class="social rounded clientgate" @click="getRegisterKauResponse">
              <client-gate-svg />Ügyfélkapu
            </b-button>

            <b-button v-else class="social rounded clientgate" @click="kauLogout">
              <client-gate-svg />Ügyfélkapu kijelentkezés
            </b-button>
          </b-col>

          <b-col cols="6" class="mt-3">
            <b-button @click="authenticateFacebook" class="social rounded facebook" :disabled="!!relayState">
              <FacebookIcon :size="24" />Facebook
            </b-button>
          </b-col>

          <b-col cols="6" class="mt-3">
            <b-button class="social rounded linkedin" @click="authenticateLinkedIn" :disabled="!!relayState">
              <LinkedInIcon :size="24" />LinkedIn</b-button
            >
          </b-col>
        </b-row>
        <div class="text-left my-1" v-if="relayState">
          <hr class="mt-3 mb-3" />
          <b style="color: #00903C;">Sikeres Ügyfélkapus azonosítás!</b>
        </div>
        <hr class="horizontal-ruler" />
        <p>Hozzon létre új vali.hu felhasználót</p>

        <b-row cols="1" class="justify-content-md-center pt-2 ">
          <b-col>
            <b-form>
              <b-row>
                <b-form-group id="input-group-1" label-for="input-1" description="" class="col-12 col-md-6">
                  <label for="name">Név</label>
                  <b-form-input
                    id="name"
                    type="text"
                    required
                    placeholder="Teljes név"
                    class="border inputFieldAlign"
                    v-model="fullName"
                    :disabled="
                      (disabledSocialSourceField && fullName != '') || (disabledKauSourceField && fullName != '')
                    "
                    @input="fullNameCheck"
                    :state="isFullnameValid"
                    :class="{ 'input-error': !isFullnameValid }"
                  ></b-form-input>
                  <b-form-invalid-feedback id="name-error">
                    <div class="error-box">
                      <div><AlphaXCircleOutline class="mr-2" :size="20" /></div>
                      <div class="error-text">A mező kitöltése kötelező</div>
                    </div>
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group id="input-group-2" label-for="input-2" description="" class="col-12 col-md-6">
                  <label for="username">Felhasználónév</label>
                  <b-form-input
                    id="username"
                    type="text"
                    required
                    placeholder="Felhasználónév"
                    class="border inputFieldAlign"
                    v-model="userName"
                    @input="userNameCheck"
                    :state="isUsernameValid"
                    :class="{ 'input-error': !isUsernameValid }"
                  ></b-form-input>
                  <b-form-invalid-feedback id="phone-error">
                    <div class="error-box">
                      <div><AlphaXCircleOutline class="mr-2" :size="20" /></div>
                      <div v-if="!userName" class="error-text">A mező kitöltése kötelező</div>
                      <div class="error-text" v-else>A felhasználónévnek minimum 6 karakter hosszúnak kell lennie</div>
                    </div>
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-row>
              <b-row>
                <b-form-group id="input-group-4" label-for="input-4" description="" class="col-12 col-md-6">
                  <label for="email">Email cím</label>
                  <b-form-input
                    id="email"
                    type="email"
                    required
                    placeholder="Email cím"
                    class="border inputFieldAlign"
                    v-model="email"
                    :disabled="disabledSocialSourceField && email != ''"
                    @input="emailCheck"
                    :state="emailValid"
                    :class="{ 'input-error': !emailValid }"
                  ></b-form-input>
                  <b-form-invalid-feedback id="phone-error">
                    <div class="error-box">
                      <div><AlphaXCircleOutline class="mr-2" :size="20" /></div>
                      <div v-if="!email" class="error-text">A mező kitöltése kötelező</div>
                      <div v-else class="error-text">Érvénytelen e-mail cím</div>
                    </div>
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group id="input-group-3" label-for="input-3" description="" class="col-12 col-md-6">
                  <label for="phone">Telefonszám</label>
                  <b-form-input
                    id="phone"
                    type="text"
                    required
                    placeholder="Telefonszám +36000000000"
                    class="border inputFieldAlign"
                    v-model="phoneNumber"
                    @input="phoneNumberCheck"
                    :state="phoneNumberValid"
                    :class="{ 'input-error': !phoneNumberValid }"
                  ></b-form-input>
                  <b-form-invalid-feedback id="phone-error">
                    <div class="error-box">
                      <div><AlphaXCircleOutline class="mr-2" :size="20" /></div>
                      <div class="error-text" v-if="!phoneNumber">A mező kitöltése kötelező</div>
                      <div class="error-text" v-else>
                        A telefonszámnak +36 vagy 06-al kell kezdődnie és csak számokból állhat
                      </div>
                    </div>
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-row>
              <b-row>
                <b-form-group class="col-12 col-md-6">
                  <label for="password">Jelszó</label>
                  <b-input-group id="input-group-6" label-for="input-6" description="">
                    <b-form-input
                      id="password"
                      :type="passwordFieldType"
                      required
                      placeholder="Jelszó"
                      autocomplete
                      class="border inputFieldAlign"
                      v-model="password"
                      @input="passwordCheck"
                      :state="isValidPassword"
                      :class="{ 'input-error': !isValidPassword }"
                    ></b-form-input>
                    <b-input-group-append>
                      <span class="input-group-text border" @click="switchPasswordVisibility">
                        <eye-icon v-if="passwordFieldType == 'password'" title="Jelszó megjelenítése" />
                        <eye-off-icon v-if="passwordFieldType == 'text'" title="Jelszó elrejtése" />
                      </span>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
                <b-form-group class="col-12 col-md-6">
                  <label for="new-password">Jelszó újra</label>
                  <b-input-group id="input-group-7" label-for="input-7" description="">
                    <b-form-input
                      id="new-password"
                      :type="passwordFieldType"
                      required
                      placeholder="Jelszó újra"
                      autocomplete
                      class="border inputFieldAlign"
                      v-model="verifyPassword"
                      :state="isValidPassword"
                      :class="{ 'input-error': verifyPassword !== password }"
                    ></b-form-input>
                    <b-input-group-append>
                      <span class="input-group-text border" @click="switchPasswordVisibility">
                        <eye-icon v-if="passwordFieldType == 'password'" title="Jelszó megjelenítése" />
                        <eye-off-icon v-if="passwordFieldType == 'text'" title="Jelszó elrejtése" />
                      </span>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-row>
              <b-row class="mt-3">
                <b-form-group class="col-12 col-md-6">
                  <small
                    class="form-text text-left text-muted"
                    v-bind:class="{
                      'text-success': valid_password_length,
                      'ml-1': valid_password_length,
                      'ml-4': !valid_password_length
                    }"
                  >
                    Minimum 10 karakter
                  </small>
                  <small
                    class="form-text text-left text-muted"
                    v-bind:class="{
                      'text-success': contains_uppercase,
                      'ml-1': contains_uppercase,
                      'ml-4': !contains_uppercase
                    }"
                  >
                    1 nagybetű
                  </small>
                  <small
                    class="form-text text-left text-muted"
                    v-bind:class="{
                      'text-success': contains_number,
                      'ml-1': contains_number,
                      'ml-4': !contains_number
                    }"
                  >
                    1 szám
                  </small>
                  <small
                    class="form-text text-left text-muted"
                    v-bind:class="{
                      'text-success': contains_special,
                      'ml-1': contains_special,
                      'ml-4': !contains_special
                    }"
                  >
                    1 különleges karakter ( @ $ ! % * ? &)
                  </small>
                  <small
                    class="form-text text-left text-muted"
                    v-bind:class="{
                      'text-success': contains_hungarian,
                      'ml-1': contains_hungarian,
                      'ml-4': !contains_hungarian
                    }"
                  >
                    Nem tartalmaz ékezetes karaktert
                  </small>
                  <small
                    class="form-text text-left text-muted"
                    v-bind:class="{
                      'text-success': verifyPassword == password && password != '',
                      'ml-1': verifyPassword == password && password != '',
                      'ml-4': !(verifyPassword == password && password != '')
                    }"
                  >
                    A jelszavak megegyeznek
                  </small>
                  <div class="password-validator-container">
                    <p v-bind:class="{ password_length_valid: truthyPasswordRulesCount1 }"></p>

                    <p v-bind:class="{ uppercase_valid: truthyPasswordRulesCount2 }"></p>

                    <p v-bind:class="{ number_valid: truthyPasswordRulesCount3 }"></p>

                    <p v-bind:class="{ special_valid: truthyPasswordRulesCount4 }"></p>

                    <p v-bind:class="{ hungarian_valid: truthyPasswordRulesCount5 }"></p>
                  </div>
                </b-form-group>
                <b-form-group class="text-center mb-2 col-12 col-md-6">
                  <vue-recaptcha
                    sitekey="6LeWGWcaAAAAANlpLemRvVaYx0lCci6o09Op9v5D"
                    :loadRecaptchaScript="true"
                    ref="invisibleRecaptcha"
                    @verify="onVerify"
                    @expired="onExpired"
                  ></vue-recaptcha>
                </b-form-group>
              </b-row>
              <b-form-group class="text-left">
                <b-form-checkbox
                  id="terms-checkbox"
                  v-model="terms_accepted"
                  name="terms-checkbox"
                  :value="true"
                  :unchecked-value="false"
                  class="mt-2"
                  v-bind:class="[terms_accepted ? 'terms-checkbox' : '', 'terms-checkbox_na']"
                >
                  Elfogadom a
                  <a download target="_blank" href="https://vali.hu/static/felhasznalasi_feltetelek.pdf">
                    Felhasználási feltételeket
                  </a>
                </b-form-checkbox>
              </b-form-group>

              <b-row>
                <b-col class="col-12 col-md-6">
                  <b-button
                    :disabled="
                      !contains_lowercase ||
                        !contains_number ||
                        !contains_uppercase ||
                        !contains_special ||
                        !phoneNumberValid ||
                        !emailValid ||
                        password != verifyPassword ||
                        !isUsernameValid ||
                        !isFullnameValid ||
                        !terms_accepted ||
                        !gCaptchaVerified ||
                        !isValidPassword
                    "
                    type="submit"
                    variant="primary"
                    class="registratin-button"
                    size="lg"
                    @click.prevent="onRegistrationSubmit"
                    ><b-spinner small v-if="isLoading"></b-spinner>
                    <span class="sr-only" v-if="isLoading">Betöltés...</span>
                    <span v-if="!isLoading">Regisztráció</span>
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-col>
        </b-row>
      </div>

      <b-modal ref="registration-finished" id="registration-finished" hide-footer>
        <h4 class="text-center mb-5">Erősítse meg a regisztrációját!</h4>
        <div class="d-block text-center">
          <svg
            version="1.1"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="125px"
            height="100px"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g transform="matrix(1 0 0 1 -124 -231 )">
              <path
                d="M 99.8470102999995 69.3003905999999  C 100.142174899999 69.4656249999998  100.471351899999 69.5494140999997  100.801897099999 69.5494140999997  C 101.038810699999 69.5494140999997  101.276310699999 69.5064452999998  101.5026687 69.4195312999998  C 102.044911499999 69.2115233999998  102.4665473 68.7732421999997  102.653028799999 68.2236327999999  C 102.653028799999 68.2236327999999  124.873450599999 2.77480468999988  124.873450599999 2.77480468999988  C 124.882051399999 2.74667968999984  124.901989699999 2.67871093999975  124.909808599999 2.64999999999986  C 124.917627599999 2.62128905999975  124.924469099999 2.59238280999989  124.930919799999 2.5634765599998  C 124.936393099999 2.53203124999982  124.956526699999 2.42187499999977  124.960631699999 2.39062499999977  C 124.963368299999 2.35859374999973  124.973337399999 2.2509765599998  124.974510299999 2.21894530999975  C 124.967864199999 2.18984374999991  124.914109099999 1.6574218799999  124.906094699999 1.62851562999981  C 124.898666699999 1.60175780999975  124.890065799999 1.5753906299999  124.881464999999 1.54882812999995  C 124.872473299999 1.52109374999986  124.863676999999 1.4931640599998  124.853316899999 1.46562499999982  C 124.842370399999 1.43574218999993  124.829469099999 1.40664062999986  124.816958799999 1.37753905999989  C 124.806794199999 1.35410155999989  124.797607 1.33066405999989  124.786855999999 1.30761718999975  C 124.766917699999 1.26601562999986  124.745024699999 1.22558593999975  124.722154299999 1.18535155999984  C 124.692246899999 1.13457030999984  124.642987699999 1.05390624999995  124.608584399999 1.00585937999995  C 124.5827819 0.971679692999942  124.528831299999 0.902343749999773  124.500878599999 0.869921874999818  C 124.483872399999 0.850195312999858  124.465888899999 0.832421874999909  124.448296299999 0.813671874999954  C 124.426598799999 0.790429687999904  124.405096699999 0.767187499999864  124.382226299999 0.744726562999858  C 124.360724299999 0.724023437999904  124.338049399999 0.704492187999904  124.3153745 0.684765624999955  C 124.294849799999 0.666601562999858  124.274715999999 0.648046874999864  124.253213999999 0.630468749999864  C 124.2279979 0.610351562999767  124.201609099999 0.591406249999864  124.175806599999 0.572265624999773  C 124.155086399999 0.557226562999858  124.135148099999 0.541992187999767  124.113841599999 0.527734374999909  C 124.086084399999 0.508984374999955  124.056958799999 0.491796874999864  124.028419799999 0.474609374999773  C 124.001248999999 0.459570311999869  123.908594699999 0.408203124999773  123.880837399999 0.394335937999813  C 123.855425899999 0.382031249999955  123.8300144 0.369140624999773  123.804211899999 0.358007812999858  C 123.773327099999 0.345898437999722  123.671094699999 0.305078124999909  123.639427999999 0.294921874999773  C 123.604438299999 0.284570312999904  123.507678999999 0.255468749999864  123.472298399999 0.247070312999767  C 123.436526799999 0.239648437999676  123.340353899999 0.220507812999813  123.304191399999 0.215039062999949  C 123.269592699999 0.211328125999898  123.170096699999 0.200195312999767  123.135302499999 0.198046874999818  C 123.104026799999 0.200390624999727  122.826454699999 0.204882812999813  122.7953745 0.208398437999904  C 122.763512399999 0.213281249999909  122.654242799999 0.230078124999864  122.622576099999 0.236718749999909  C 122.587977299999 0.245507811999914  122.481835399999 0.271289062999813  122.447432099999 0.281835937999858  C 122.408728399999 0.295117187999949  122.309232499999 0.329687499999864  122.2713107 0.345507812999813  C 122.2713107 0.345507812999813  44.6768353999992 34.3804687999998  44.6768353999992 34.3804687999998  C 43.9983476999996 34.6783202999998  43.5464135999996 35.3337890999999  43.5102509999992 36.0734374999997  C 43.4740884999992 36.8130858999998  43.8597571999994 37.5097655999998  44.5059917999993 37.8720702999999  C 44.5059917999993 37.8720702999999  62.7166707999995 48.0832030999998  62.7166707999995 48.0832030999998  C 62.7166707999995 48.0832030999998  71.0266295999995 72.5550780999997  71.0266295999995 72.5550780999997  C 71.0440266999994 72.6056640999996  71.0700246999995 72.6759765999998  71.0911357999994 72.7244140999999  C 71.1059916999993 72.7554687999998  71.1519279999993 72.8511718999998  71.1683476999992 72.8812499999997  C 71.1802715999993 72.9033202999999  71.1933682999993 72.9251952999998  71.2062694999995 72.9468749999999  C 71.2242530999993 72.9769530999997  71.2430184999994 73.0064452999998  71.2621748999995 73.0353515999998  C 71.2895411 73.0728515999997  71.3579567999996 73.1667968999998  71.3876686999993 73.2021483999997  C 71.4267633999993 73.2470702999997  71.4906830999994 73.3175780999998  71.5334917999994 73.3585937999999  C 71.5628127999994 73.3853515999999  71.6331830999993 73.4472655999998  71.6640678999993 73.4720702999998  C 71.6920205999991 73.4927733999998  71.7743147999995 73.5539062999999  71.8032448999993 73.5732421999999  C 71.8378436999997 73.5947265999998  71.9332345999992 73.6533202999999  71.9693970999992 73.6726562999997  C 72.0016501999994 73.6896483999999  72.0340987999994 73.7052733999999  72.0667427999992 73.7203124999999  C 72.0950863999992 73.7333983999997  72.1236254999994 73.7468749999998  72.1527509999992 73.7583983999998  C 72.1775760999994 73.7685546999999  72.2027921999993 73.7773437999997  72.2282036999995 73.7863280999998  C 72.2561563999993 73.7964843999998  72.2844999999993 73.8060546999998  72.3130390999995 73.8146483999999  C 72.3439238999995 73.8228515000001  72.4494793999993 73.8509765999997  72.4809505999992 73.8576171999998  C 72.5169176999993 73.8638671999997  72.6220822999994 73.8822265999997  72.6586357999995 73.8865233999998  C 72.7127818999993 73.8912108999998  72.8251789999995 73.9009765999997  72.8806933999995 73.9009765999997  C 72.9408990999996 73.9009765999997  73.0040369999992 73.8976562999999  73.0632653999992 73.8921874999999  C 73.1060739999994 73.8871093999999  73.1999011999992 73.8748046999997  73.2417324999992 73.8669921999997  C 73.2831727999992 73.8582031999997  73.3828641999994 73.8357421999997  73.4233271999992 73.8240233999998  C 73.4776687999993 73.8066405999998  73.5836151999993 73.7728515999997  73.6360020999991 73.7509765999998  C 73.6723600999994 73.7345703999997  73.7603229999995 73.6935546999998  73.7955081999994 73.6751952999998  C 73.8289340999991 73.6558593999998  73.9251069999996 73.6001952999998  73.9571645999995 73.5791015999998  C 74.0048599999991 73.5455078999998  74.1047468999996 73.4744140999999  74.1491192999993 73.4369140999997  C 74.1858682999996 73.4041015999996  74.2533065999992 73.3417968999997  74.2877098999993 73.3062499999999  C 74.2877098999993 73.3062499999999  85.5839135999995 61.3201171999999  85.5839135999995 61.3201171999999  C 85.5839135999995 61.3201171999999  99.8470102999995 69.3003905999999  99.8470102999995 69.3003905999999  Z M 69.5076655999992 77.036582  C 68.869495090707 76.3062388606513  67.8069374243328 76.1650041275657  67.0081236887286 76.6589802210037  C 66.9182645181186 76.7145479711301  66.8317428088067 76.7781537888741  66.7495380999994 76.8498632999999  C 66.6633343999993 76.9252538999999  61.5520997999993 81.3254491999999  55.6646408999995 83.3932227  C 56.9375627999993 77.5510351999999  55.1859269999995 71.9938086  51.0847026999995 69.2418554999999  C 48.9229639999994 67.7914647999999  46.4130873999993 67.208457  44.0165853999993 67.6004492  C 41.7526141999992 67.9707616999999  39.7413898999994 69.1563085999999  38.3537252999995 70.9381444999999  C 36.8835709899995 72.8258398  36.2781903299992 75.1918555  36.6493940299993 77.6004492  C 37.0501141999994 80.2004491999999  38.5787149999992 82.755332  41.0700215999996 84.9881444999999  C 43.3814927999993 87.0602148  46.1566264999992 88.1752538999999  49.3080462999992 88.3289648  C 45.3243013999995 93.9674413999999  38.1437869999995 96.0926367  31.9547129599996 96.0926367  C 30.8753096699993 96.0926367  29.9999804499994 96.9670507999999  29.9999804499994 98.0457617  C 29.9999804499994 99.1242772999999  30.8753096699993 99.9988867  31.9547129599996 99.9988867  C 43.8625524999993 99.9988867  50.9281285999996 94.1816991999999  54.0719248999994 87.8908789  C 55.8526861999994 87.5000585999999  57.7204330999994 86.8582617  59.6630462999992 85.9654883000001  C 65.0584989999993 83.4852148  69.1491676999995 79.9420508000001  69.3207931999996 79.7926367  C 70.1341573999994 79.0830664  70.2176244999991 77.849082  69.5076655999992 77.036582  Z M 76.8665884999996 54.2302733999998  C 76.8532962999993 54.2548827999997  76.8401995999993 54.2798827999998  76.8276892999993 54.3050780999997  C 76.8106830999996 54.3400390999998  76.7948497999996 54.3755858999998  76.7799937999994 54.4119140999996  C 76.7676789999996 54.4406249999997  76.7559505999993 54.4697265999998  76.7451995999995 54.4990233999997  C 76.7451995999995 54.4990233999997  72.8842118999996 65.8679687999997  72.8842118999996 65.8679687999997  L 66.6300452999994 47.4501952999997  L 110.3343457 14.2417968999998  C 110.3343457 14.2417968999998  77.0831727999994 53.9093749999997  77.0831727999994 53.9093749999997  C 77.0546336999992 53.9451171999997  76.9991192999996 54.0187499999997  76.9727304999997 54.0568358999997  C 76.9584608999994 54.0777343999998  76.9449732999997 54.0988280999998  76.9314855999996 54.1201171999999  C 76.9086151999995 54.1558593999998  76.8873085999994 54.1927733999999  76.8665884999996 54.2302733999998  Z M 64.1649320999995 44.4160155999998  L 49.8381110999994 36.3826171999999  L 108.742020599999 10.5443358999999  L 64.1649320999995 44.4160155999998  Z M 99.7060740999996 64.7445313000001  L 81.5946954999995 54.6109375000001  L 117.817257199999 11.3984375  L 99.7060740999996 64.7445313000001  Z M 43.6805668999996 82.0805272999999  C 39.7507725999994 78.5578710999998  39.9458548999996 75.2541601999999  41.4390750999996 73.3369726999999  C 42.3447026999997 72.1742772999999  43.8236532999995 71.3830664  45.5033548999995 71.3830664  C 46.5872540999994 71.3830664  47.7548157999995 71.7127539000001  48.9051758999994 72.4848242  C 51.9158548999994 74.5049414  52.9731697999996 79.0299413999999  51.5356594999994 83.7445897999999  C 51.4690030999996 83.9629491999999  51.3988281999996 84.1779882999999  51.3251347999994 84.3897069999998  C 48.5935915999994 84.6406835999999  45.9105256999997 84.0795507999999  43.6805668999996 82.0805272999999  Z M 77.6220925999996 64.0708983999998  L 79.6776892999997 58.0154296999999  L 82.0681316999994 59.3529296999998  L 77.6220925999996 64.0708983999998  Z M 24.9867512695942 64.2091935554365  C 24.9260811427293 64.246788375604  24.8676643662902 64.2898214167883  24.8121622947892 64.3383370786416  C 24.7539602283814 64.3893432115672  21.3030130461111 67.3663316739292  17.3279832750873 68.7653009088351  C 18.1874206885168 64.8127207171206  17.0047704872577 61.0529331752061  14.2357509548842 59.1910765826906  C 12.7762119864383 58.209802778817  11.0816210982375 57.8153640378669  9.46357722597895 58.0805695974327  C 7.9350140421684 58.3311075769557  6.57709773149872 59.13319912114  5.64018960341036 60.3387149117964  C 4.64758697984917 61.6158507535974  4.23885272162761 63.2165982114814  4.48947795463164 64.8461521668289  C 4.76003179333429 66.6052036348719  5.79209567542966 68.3337306887249  7.47414867519637 69.844358421798  C 9.03478238677326 71.2462346922223  10.9084666474091 72.0006236021379  13.0362076200031 72.1046179807145  C 10.3465065373061 75.9193758810054  5.49844577016211 77.3571943088295  1.31977480499063 77.3571943088295  C 0.590995159040176 77.3571943088295  0 77.9487863881691  0 78.6785971544148  C 0 79.408275788833  0.590995159040176 80  1.31977480499063 80  C 9.35957898605648 80  14.1300369754845 76.0643337647091  16.2526307971643 71.8082273478208  C 17.4549456332961 71.5438146468762  18.7159904504815 71.1096016549029  20.0275826729912 70.5055884395567  C 23.6704251072119 68.8275389236633  26.4323178256295 66.430382063772  26.5481940438003 66.3292947207137  C 27.0973523419048 65.8492290753697  27.1537067408121 65.0143667406151  26.6743644962821 64.4646631568517  C 26.2434915481199 63.970543475526  25.5260855451215 63.8749899506904  24.9867512695942 64.2091935554365  Z M 7.67434280141561 61.3462126887653  C 8.29255844177715 60.5451326673492  9.30214603853528 60  10.4487738580283 60  C 11.1886844327669 60  11.9857061931762 60.227149836114  12.7709854910554 60.7590949117193  C 14.8261888063121 62.1509259362842  15.5479519327532 65.268584350438  14.5666530515787 68.516907721496  C 14.5211508727466 68.6673541349146  14.4732468327852 68.8155129104919  14.4229409316936 68.9613839793292  C 12.5582862672782 69.1343031635824  10.7267240407064 68.74769092151  9.20446985198487 67.370393145849  C 6.52184368239386 64.9433348603018  6.65501423618207 62.6671266646517  7.67434280141561 61.3462126887653  Z "
                fill-rule="nonzero"
                stroke="none"
                transform="matrix(1 0 0 1 124 231 )"
              />
            </g>
          </svg>
          <div class="mt-5 text-center">
            A(z) <br /><br />
            <strong>{{ email }}</strong> <br />
            <br />
            címre kiküldtünk Önnek egy linket <br />
            amin keresztül be tudja fejezni a <br />
            regisztrációs folyamatot. <br /><br />
            <b-button @click="goToLogin" variant="primary" class="">Bejelentkezés</b-button>
          </div>
        </div>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import AlphaXCircleOutline from 'vue-material-design-icons/AlphaXCircleOutline.vue'
import EyeIcon from 'vue-material-design-icons/Eye.vue'
import EyeOffIcon from 'vue-material-design-icons/EyeOff.vue'
import FacebookIcon from 'vue-material-design-icons/Facebook.vue'
import GooglePlusIcon from 'vue-material-design-icons/GooglePlus.vue'
import LinkedInIcon from 'vue-material-design-icons/Linkedin.vue'
import VueRecaptcha from 'vue-recaptcha'
import { mapGetters } from 'vuex'
import * as KauApi from '../api/kau'
import * as UserApi from '../api/user'
import ClientGateSvg from '../components/svg/ClientGate'

export default {
  name: 'Register',
  data() {
    return {
      facebookId: '',
      linkedinId: '',
      googleId: '',
      userName: '',
      phoneNumber: '',
      fullName: '',
      password: '',
      verifyPassword: '',
      email: '',
      fbmodel: {},
      FB: {},
      fbloginOptions: { scope: 'email,name,user_photos' },
      password_length: 0,
      typed: false,
      contains_lowercase: false,
      contains_number: false,
      contains_uppercase: false,
      contains_special: false,
      contains_hungarian: false,
      valid_password_length: false,
      valid_password: false,
      canSendForm: false,
      passwordFieldType: 'password',
      disabledSocialSourceField: false,
      disabledKauSourceField: false,
      terms_accepted: false,
      isValidPassword: true,
      emailValid: true,
      phoneNumberValid: true,
      gCaptchaVerified: false,
      isUsernameValid: true,
      isFullnameValid: true,
      relayState: ''
    }
  },
  components: {
    AlphaXCircleOutline,
    FacebookIcon,
    GooglePlusIcon,
    LinkedInIcon,
    EyeIcon,
    EyeOffIcon,
    VueRecaptcha,
    ClientGateSvg
  },
  computed: {
    ...mapGetters(['isLoading', 'selectedCompany']),
    loginUrl() {
      const companyIdFromQuery = this.$route.query.companyId
      const selectedCompanyId = this.selectedCompany?.flaggerId ? this.selectedCompany?.flaggerId : companyIdFromQuery

      return selectedCompanyId !== undefined ? '/login?companyId=' + this.$route.query.companyId : '/login'
    },
    truthyPasswordRulesCount() {
      const rules = [
        this.valid_password_length,
        this.contains_uppercase,
        this.contains_number,
        this.contains_special,
        this.contains_hungarian
      ]
      const count = rules.filter(Boolean).length

      return count
    },
    truthyPasswordRulesCount1() {
      return this.truthyPasswordRulesCount >= 1 ? true : false
    },
    truthyPasswordRulesCount2() {
      return this.truthyPasswordRulesCount >= 2 ? true : false
    },
    truthyPasswordRulesCount3() {
      return this.truthyPasswordRulesCount >= 3 ? true : false
    },
    truthyPasswordRulesCount4() {
      return this.truthyPasswordRulesCount >= 4 ? true : false
    },
    truthyPasswordRulesCount5() {
      return this.truthyPasswordRulesCount >= 5 ? true : false
    }
  },
  methods: {
    async kauLogout(relayState) {
      try {
        await UserApi.kauLogout(relayState)
        this.$router.push('/')
      } catch (error) {
        console.log(error)
      }
    },
    async getRegisterKauResponse() {
      try {
        const response = await KauApi.createRequest({
          callbackUrl: `${window._env_.VUE_APP_API_URL}/api/v1/kau/processRegisterResponse`
        })

        const RelayState = response.relayState
        const SAMLRequest = response.samlRequest

        const url = `${window._env_.VUE_APP_KAU_BASE_URL}/proxy/saml/authnrequest`

        const form = document.createElement('form')
        form.action = url
        form.method = 'POST'

        const samlInput = document.createElement('input')
        samlInput.type = 'hidden'
        samlInput.name = 'SAMLRequest'
        samlInput.value = SAMLRequest

        const relayStateInput = document.createElement('input')
        relayStateInput.type = 'hidden'
        relayStateInput.name = 'RelayState'
        relayStateInput.value = RelayState

        // Audience input
        const audienceInput = document.createElement('input')
        audienceInput.type = 'hidden'
        audienceInput.name = 'Audience'
        audienceInput.value = 'urn:eksz.gov.hu:1.0:azonositas:kau:3:dap:qr' // Az Audience URI

        form.appendChild(relayStateInput)
        form.appendChild(samlInput)
        form.appendChild(audienceInput) // Hozzáadva az Audience input

        document.body.appendChild(form)
        form.submit()
      } catch (error) {
        console.log(error)
      }
    },
    async getKauFullName(relayState) {
      try {
        const response = await KauApi.getFullName(relayState)
        this.fullName = response
        this.disabledKauSourceField = true
      } catch (error) {
        console.log(error)
      }
    },
    goToLogin() {
      this.$router.push('/login')
    },
    fireRecaptcha() {
      //fires recaptcha when invisible
      this.$refs.invisibleRecaptcha.execute()
    },
    onVerify() {
      this.gCaptchaVerified = true
    },
    onExpired() {
      this.gCaptchaVerified = false
    },
    resetRecaptcha() {
      this.$refs.recaptcha.reset() // Direct call reset method
    },
    switchPasswordVisibility() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
    },
    async onRegistrationSubmit() {
      const companyIdFromQuery = this.$route.query.companyId
      const sessionId = this.$route.query.sessionId
      const soleProprietorshipIdFromQuery = this.$route.query.soleProprietorshipId
      const redir = this.$route.query.redir

      let registrationData = {
        userName: this.userName,
        password: this.password,
        fullName: this.fullName,
        email: this.email,
        phoneNumber: this.phoneNumber
      }

      if (this.facebookId) registrationData = { ...registrationData, facebookId: this.facebookId }
      if (this.linkedinId) registrationData = { ...registrationData, linkedinId: this.linkedinId }
      if (this.googleId) registrationData = { ...registrationData, googleId: this.googleId }
      if (this.relayState) registrationData = { ...registrationData, relayState: this.relayState }
      if (redir) registrationData = { ...registrationData, redir: redir }
      if (sessionId) registrationData = { ...registrationData, sessionId: sessionId }

      if (companyIdFromQuery !== undefined) {
        registrationData = { ...registrationData, companyId: companyIdFromQuery }
      }

      if (soleProprietorshipIdFromQuery !== undefined) {
        registrationData = { ...registrationData, soleProprietorshipId: soleProprietorshipIdFromQuery }
      }

      const phonePattern = /^((?:\+3|0)6)(?:-|\()?(\d{1,2})(?:-|\))?(\d{3})-?(\d{3,4})[0-9]$/
      this.phoneNumberValid = phonePattern.test(this.phoneNumber)

      const emailValidationPattern = RegExp(
        /^(([^<>()[\]\\.,;:?\s@"]+(\.[^<>()[\]\\.,;:?\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/
      )
      this.emailValid = emailValidationPattern.test(this.email)
      if (
        !this.userName.length ||
        !this.password.length ||
        !this.fullName.length ||
        !this.email.length ||
        !this.phoneNumber.length
      ) {
        this.$store.dispatch('notify', {
          newNotification: { type: 'warning', message: 'Az összes mező kitöltése kötelező!' }
        })
        return
      }
      if (
        !this.contains_lowercase ||
        !this.contains_number ||
        !this.contains_special ||
        !this.valid_password_length ||
        !this.contains_hungarian
      ) {
        this.$store.dispatch('notify', {
          newNotification: { type: 'warning', message: 'Nem megfelelő jelszó erősség!' }
        })
        return
      }
      if (!this.emailValid) {
        this.$store.dispatch('notify', {
          newNotification: { type: 'warning', message: 'Az email cím formátuma nem megfelelő.' }
        })
        return
      }
      if (this.password != this.verifyPassword) {
        this.$store.dispatch('notify', {
          newNotification: { type: 'warning', message: 'A jelszavak nem egyeznek.' }
        })
        return
      }
      if (!this.phoneNumberValid) {
        this.$store.dispatch('notify', {
          newNotification: { type: 'warning', message: 'Telefonszám formátum hibás.' }
        })
        return
      }
      if (this.userName.length < 5) {
        this.$store.dispatch('notify', {
          newNotification: { type: 'warning', message: 'A felhasználónévnek min. 5 karakter hosszúnak kell lennie.' }
        })
      }

      if (!this.terms_accepted) {
        this.$store.dispatch('notify', {
          newNotification: {
            type: 'warning',
            message: 'A felhasználási feltételeket a regisztrációhoz el kell fogadni.'
          }
        })
        return
      }

      if (!this.gCaptchaVerified) {
        this.$store.dispatch('notify', {
          newNotification: { type: 'warning', message: 'Erősítse meg, hogy Ön nem robot.' }
        })
        return
      }
      await this.$store.dispatch('register', registrationData)
      this.showModal()
    },
    showModal() {
      this.$refs['registration-finished'].show()
    },
    hideModal() {
      this.$refs['registration-finished'].hide()
    },
    handleSdkInit({ FB, scope }) {
      this.FB = FB
      this.scope = scope
    },
    handleClick() {
      this.$emit('click')
      this.scope.toggleLogin?.()
    },
    handleFbLogin(res) {
      if (res.status == 'connected') {
        this.FB.api('/me', 'GET', { fields: 'id,name,last_name,first_name,email' }, response => {
          this.fullName = response.name
          this.email = response.email
          this.facebookId = response.id
          this.disabledSocialSourceField = true
        })
      }
    },
    async authenticateFacebook() {
      let profileData
      try {
        const { data } = await this.$auth.authenticate('facebook')
        profileData = data
      } catch (err) {
        console.log(JSON.stringify(err))
      }
      this.fullName = `${profileData.name}`
      this.email = profileData.email ? profileData.email : ''
      this.facebookId = profileData.facebookId
      this.disabledSocialSourceField = true
      this.validateSocialData()
    },
    async authenticateLinkedIn() {
      let profileData
      try {
        const { data } = await this.$auth.authenticate('linkedin')
        profileData = data
      } catch (err) {
        console.log(JSON.stringify(err))
      }

      this.fullName = `${profileData.firstName} ${profileData.lastName}`
      this.email = profileData.email ? profileData.email : ''
      this.linkedinId = profileData.linkedinId
      this.phoneNumber = profileData.phoneNumber ? profileData.phoneNumber : ''
      this.disabledSocialSourceField = true
      this.validateSocialData()
    },
    async authenticateGoogle() {
      let profileData
      try {
        const { data } = await this.$auth.authenticate('google')
        profileData = data
      } catch (err) {
        console.log(JSON.stringify(err))
      }
      this.email = profileData.email
      this.fullName = profileData.name
      this.googleId = profileData.googleId
      this.disabledSocialSourceField = true
      this.validateSocialData()
    },
    validateSocialData: function() {
      this.fullNameCheck()
      this.emailCheck()
      this.phoneNumberCheck()
    },
    fullNameCheck: function() {
      if (this.fullName.length > 1 && this.fullName.length < 255) {
        this.isFullnameValid = true
      } else {
        this.isFullnameValid = false
      }
    },
    userNameCheck: function() {
      if (this.userName.length > 5 && this.userName.length < 255) this.isUsernameValid = true
      else this.isUsernameValid = false
    },
    phoneNumberCheck: function() {
      const phonePattern = /^((?:\+3|0)6)(?:-|\()?(\d{1,2})(?:-|\))?(\d{3})-?(\d{3,4})[0-9]$/
      this.phoneNumberValid = phonePattern.test(this.phoneNumber)
    },
    emailCheck: function() {
      const emailValidationPattern = RegExp(
        /^(([^<>()[\]\\.,;:?\s@"]+(\.[^<>()[\]\\.,;:?\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/
      )
      this.emailValid = emailValidationPattern.test(this.email)
    },
    passwordCheck: function() {
      this.password_length = this.password.length
      if (this.password_length >= 10) {
        this.valid_password_length = true
      } else {
        this.valid_password_length = false
      }

      if (this.password_length > 0) {
        this.typed = true
      } else {
        this.typed = false
      }
      this.contains_lowercase = /[a-z]/.test(this.password)
      this.contains_number = /\d/.test(this.password)
      this.contains_uppercase = /[A-Z]/.test(this.password)
      const specialPattern = /^(?=.*[@$!%*?&]).*$/
      this.contains_special = specialPattern.test(this.password)
      const hungarianCharactersPattern = /^(?:(?![űáéúőóüöí]).)*$/
      this.contains_hungarian = hungarianCharactersPattern.test(this.password)

      const wholePasswordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{10,}$/
      this.isValidPassword = wholePasswordPattern.test(this.password)

      // Check if the password is valid
      if (this.contains_lowercase == true && this.contains_number == true) {
        this.valid_password = false
        if (this.contains_uppercase == true && this.valid_password_length == true) this.valid_password = true
      } else {
        this.valid_password = false
      }
    }
  },
  async created() {
    this.relayState = this.$route.query.relayState

    if (this.relayState) {
      this.getKauFullName(this.relayState)
    }
  },
  beforeDestroy() {
    if (this.relayState) {
      this.kauLogout(this.relayState)
    }
  }
}
</script>

<style scoped>
.horizontal-ruler {
  margin-top: 16px;
  margin-bottom: 32px;
}
.inputFieldAlign {
  background-image: none;
}
.input-error {
  border-color: var(--color-red) !important;
}
.error-box {
  display: flex;
  justify-content: flex-end;
}
.error-text {
  margin-top: 1.5px;
}
.social {
  min-width: 100px;
  width: 100%;
  padding-left: 10px;
  font-size: 18px;
  color: white;
  border: 0;
  min-height: 48px;
  line-height: 48px;
  display: flex;
  align-items: center;
  display: inline-flex;
  justify-content: center;
}

.social.facebook {
  background-color: #4267b2;
}

.social.google {
  background-color: #db4437;
}

.social.linkedin {
  background-color: #0e76a8;
}

.social.clientgate {
  background-color: #772860;
}
@media all and (max-width: 767px) {
  .social.clientgate {
    font-size: 14px;
  }
}

@media all and (max-width: 467px) {
  .social.clientgate {
    font-size: 13px;
  }
}

@media all and (max-width: 445px) {
  .social.clientgate {
    font-size: 9px;
  }
}
.social.clientgate:disabled {
  background-color: #772860 !important;
  opacity: 0.3;
}

.social svg {
  margin-right: 10px;
}

.bordered-container {
  max-width: 600px;
  margin: 0;
}

.registratin-button {
  margin-top: 75px;
  margin-bottom: 125px;
  width: 50%;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
}

@media (max-width: 5763px) {
  .registratin-button {
    margin-top: 35px;
    margin-bottom: 125px;
    width: 100%;
  }
}
</style>
